import { itemWidth } from "glider-js";

export default () => {
    const megaMenuNavigation = document.querySelectorAll('.js-navigation');
    if(megaMenuNavigation){
      megaMenuNavigation.forEach( nav => {
        nav.querySelectorAll('.has-sub').forEach(sub => {
          sub.addEventListener('click', ev => { 
            ev.currentTarget.classList.toggle('is-active')
          })
        })

        nav.querySelectorAll('.Navigation__Item').forEach(item => {
          item.addEventListener('click', e => {
            if (e.currentTarget.hash) {
              window.location.reload()
            }
          })
        }) 
      });
    }
}
